import { ActionIcon, Button, Group, Popover, Select } from "@mantine/core";
import { Icon3dRotate } from "@tabler/icons-react";
import { useContext, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { makeSafeRequest } from "../../../common/makeSafeRequest";
import { AppInfoContext } from "../../../components/contexts/AppInfoContext";

interface IForcePackageCopyPopover {
	fp_id: number;
}

export const ForcePackageCopyPopover: React.FC<IForcePackageCopyPopover> = ({ fp_id }) => {
	const { pid } = useParams<{ pid: string }>();
	const { projects } = useContext(AppInfoContext);
	const [opened, setOpened] = useState(false);
	const [selectedProject, setSelectedProject] = useState<number | null>(null);

	const data = useMemo(
		() =>
			projects
				?.filter((project) => project.id.toString() !== pid)
				.map((project) => ({ value: project.id.toString(), label: project.name })) || [],
		[projects, pid]
	);

	return (
		<Popover key="copy-to-project-popover" opened={opened} onChange={setOpened} position="bottom" withArrow>
			<Popover.Target>
				<ActionIcon color={"gray"} title="Copy to other project" onClick={() => setOpened((o) => !o)}>
					<Icon3dRotate size="1.1rem"></Icon3dRotate>
				</ActionIcon>
			</Popover.Target>
			<Popover.Dropdown pos={"fixed"}>
				<Group dir="row" spacing="xs">
					<Select
						data={data}
						placeholder="Choose a project"
						value={selectedProject ? selectedProject.toString() : null}
						onChange={(value) => {
							setSelectedProject(value ? parseInt(value) : null);
						}}
					/>
					<Button
						disabled={selectedProject === null}
						onClick={() => {
							makeSafeRequest(`force-packages/${fp_id}/copy-to-project/`, "POST", {
								params: { dest_pid: selectedProject },
								onSuccessMessage: "Force Package copied successfully",
								onErrorMessage: "Failed to copy Force Package",
							});
							setOpened(false);
						}}
					>
						Copy
					</Button>
				</Group>
			</Popover.Dropdown>
		</Popover>
	);
};
